import React, { FC, useEffect, useState } from 'react';

import { useAppDispatch } from 'Libs/redux/store';
import { Campaign } from 'Store/entities/activity/activity.type';
import { useTypedSelector } from 'Libs/redux/utils';
import { fetchCampaignById } from 'Store/entities/activity/activity.thunks';
import { activityActions } from 'Store/entities/activity/activity.slice';
import SPageLoaderWithTimer from 'Components/structural/SPageLoaderWithTimer/SPageLoaderWithTimer';

import styles from '../Campaign.style';
import { inferIdFromPath, redirectToActivityList } from '../routing.utils';

export const withFetchCampaignHoc = (Component: FC<{ campaign: Campaign }>) => {
  return function CampaignPage() {
    const dispatch = useAppDispatch();

    const [campaignId] = useState(() => inferIdFromPath());
    const { loading, campaign } = useTypedSelector((state) => state.entities.activity.edition);

    const showLoader = !campaign || loading;

    useEffect(() => {
      if (campaignId && !campaign) {
        dispatch(fetchCampaignById(campaignId));
      }

      return () => {
        dispatch(activityActions.resetEdition());
      };
    }, []);

    if (!campaignId) {
      redirectToActivityList();
      return null;
    }

    if (showLoader) {
      return (
        <div style={styles.container}>
          <SPageLoaderWithTimer isLoading />
        </div>
      );
    }

    return <Component campaign={campaign} />;
  };
};

export const withCampaignHoc = (Component: FC<{ campaign: Campaign }>) => {
  return function CampaignPage(props: Omit<React.ComponentProps<typeof Component>, 'campaign'>) {
    const { campaign } = useTypedSelector((state) => state.entities.activity.edition);

    if (!campaign) {
      throw new Error('No campaign found');
    }

    return <Component campaign={campaign} {...props} />;
  };
};
